import { paths } from "../paths";

import MainAcademy from '../../layouts/academy/MainAcademy';
import AboutAcademy from '../../layouts/academy/AboutAcademy';
import MissionAcademy from '../../layouts/academy/MissionAcademy';
import ProgramAcademy from '../../layouts/academy/ProgramAcademy';
import PackagesAcademy from '../../layouts/academy/PackagesAcademy';
import TrainingCenterAcademy from '../../layouts/academy/TrainingCenterAcademy';
// import GalleryAcademy from '../../layouts/academy/GalleryAcademy';

export const AcademyRoutes = [
 {
  path: paths.academy,
  element: <MainAcademy />
 },
 {
  path: paths.aboutAcademy,
  element: <AboutAcademy />
 },
 {
  path: paths.missionAcademy,
  element: <MissionAcademy />
 },
 {
  path: paths.programAcademy,
  element: <ProgramAcademy/>
 },
 {
  path: paths.packagesAcademy,
  element: <PackagesAcademy/>
 },
 {
  path: paths.trainingCenterAcademy,
  element: <TrainingCenterAcademy/>
 },
 // {
 //  path: paths.galleryAcademy,
 //  element: <GalleryAcademy/>
 // },
]